import React, {PropTypes} from 'react';

const DisplayIf = ({
  className,
  style,
  condition,
  children
}) => condition
  ? <div className={className}
      style={style}>
      {children}
    </div>
  : null;

DisplayIf.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  condition: PropTypes.bool.isRequired,
  children: PropTypes.node
};

DisplayIf.defaultProps = {
  className: '',
  style: {},
  condition: false,
  children: null
};

export default DisplayIf;



// WEBPACK FOOTER //
// ./src/features/shared/DisplayIf.jsx